/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_TitleInputs */

const en_import_title = /** @type {(inputs: Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import a recipe`)
};

const de_import_title = /** @type {(inputs: Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezept importieren`)
};

/**
* | output |
* | --- |
* | "Import a recipe" |
*
* @param {Import_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_title = /** @type {((inputs?: Import_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_title(inputs)
	return en_import_title(inputs)
});